/** User-facing product name. Cookie, storage, and analytics keys stay on the old prefix. */
export const BRAND_NAME = "Aidemia";
export const BRAND_EMAIL = "info@aidemia.co";
export const BRAND_MARK_SRC = "/logo.png";
